import script from "./DisplayCases.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayCases.vue?vue&type=script&setup=true&lang=js"

import "./DisplayCases.vue?vue&type=style&index=0&id=457f673a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457f673a"]])

export default __exports__